import * as React from "react";
import { Process, IStepConfig } from "../../../Shared/Process/Process/Process";
import { stepName, errorStepOne, ReasonMap, submitErrorMessages, TransferReason } from "../Resources/Content";
import { TransferWizardStepOne } from "./TransferWizardStepOne";
import { Contents } from "../../../Dashboard/Resoures/Contents";
import { Urls } from "../../../Dashboard/Urls";
import { TransferInstructionQuery } from "../Resources/TransferInstructionQuery";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import {
    InvestmentTransferStore,
    TransferRequestStore,
    MoveableSubAccountStore,
    DestinationSubAccountFromRequestStore,
} from "../Stores/Variable";
import { IInvestmentTransfer } from "../Stores/InvestmentTransferStoreStatic";
import { TransferWizardAction } from "../Actions/TransferWizardAction";
import { TransferWizardStepTwo } from "./TransferWizardStepTwo";
import { getQueryParameters } from "../../../Shared/Wizards/Entities/QueryParametersHelper";
import { TransferSourceAccounts } from "../../../../Wrap/Models/Domains/Transfer/TransferSourceAccounts";
import { TransferDestinationAccountModel } from "../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { Navigator } from "../../../Shared/Wizards/Entities/Navigator";
import { Lightbox, LightboxType } from "../../../../react-core/Html/Components/Lightbox";
import { Spinner } from "../../../../react-core/Html/Spinner";
import { AccountTransferInstruction } from "../../../../Wrap/Models/Models/Transfer/AccountTransferInstruction";
import { ModelPortfolioTransferInstruction } from "../../../../Wrap/Models/Models/Transfer/ModelPortfolioTransferInstruction";
import { InstrumentTransferInstruction } from "../../../../Wrap/Models/Models/Transfer/InstrumentTransferInstruction";
import { Dictionary } from "../../../../react-core/Core/Dictionary";
import { InvestmentTransferQuery } from "../Resources/TransferInstructionQuery";
import { IApiError } from "../../../../react-core/Core/ApiError";
import { InterAccountTransferErrors } from "../../../../Wrap/Validation/Errors/Transfer/InterAccount/InterAccountTransferErrors";
import { SecurityType } from "../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { JsonDateParser } from "../../../../react-core/Utils/JsonDateParser";
import { RestrictionStore } from "../../../Dashboard/Components/Clients/Common/Restrictions/Variable";
import { HierarchyIdHelper } from "../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { InvestmentSelectionAction } from "../../../Shared/IST/Action/InvestmentSelectionAction";
import { InstrumentSearchQuery } from "../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { Instrument } from "../../../../Wrap/Models/Domains/Investment/Instrument";
import { checkPermission } from "../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";

interface ITransferWizardProps extends React.Props<TransferWizard> {}

interface ITransferWizardState {
    data: TransferInstructionQuery;
    investmentData: IInvestmentTransfer[];
    destinationAccount: TransferDestinationAccountModel;
    currentAccount: TransferSourceAccounts;
    transferRequest: AccountTransferInstruction;
    errorMsg: string[];
    isLoading: boolean;
    active: boolean;
}
export class TransferWizard extends FormComponent<ITransferWizardProps, ITransferWizardState> {
    constructor(props: any) {
        super(props);
        this.state = {
            currentAccount: null,
            data: {
                Reason: TransferReason.NotSpecified,
                Detail: "",
                Reference: "",
                PensionTransferDetail: {
                    IsBlockTransfer: false,
                    IsErarmarkingOrAttachmentOrder: false,
                    ProtectedAmount: null,
                    FundValue: null,
                    ApplyAge: null,
                    TaxFreeLumpSum: false,
                    HasTransferArrangementRight: false,
                    CumlativeTotal: null,
                },
                Confirmed: false,
                IsChangeOfBeneficial: null,
                ChangeOfBeneficialOwner: null,
            },
            investmentData: InvestmentTransferStore.getInvestments(),
            destinationAccount: null,
            transferRequest: null,
            errorMsg: [],
            isLoading: false,
            active: true,
        };
        this.subscribeToStore(InvestmentTransferStore, () => this.onInvestmentTransferStoreChange());
        this.subscribeToStore(TransferRequestStore, () => this.onTransferRequestStoreChange());
        this.subscribeToStore(MoveableSubAccountStore, () => this.onMoveableSubAccountStoreChange());
        this.subscribeToStore(DestinationSubAccountFromRequestStore, () =>
            this.onDestinationSubAccountFromRequestStoreChange()
        );
    }

    child: any = {};
    private secondChild: any;

    componentDidMount() {
        const id = getQueryParameters()["hierarchyid"];
        const requestId = getQueryParameters()["requestid"];
        if (requestId) {
            TransferWizardAction.getRequest(requestId);
            this.setState({ active: false });
        } else {
            TransferWizardAction.getSourceAccount(id);
        }
    }

    private onInvestmentTransferStoreChange() {
        const data = InvestmentTransferStore.getInvestments();
        let hasModel = false;
        if (getQueryParameters()["requestid"]) {
            data.forEach((investment) => {
                if (investment.detail.SecurityType == SecurityType.Model && investment.subInvestment == undefined) {
                    hasModel = true;
                    TransferWizardAction.getModelPortofoilo(investment.detail.InstrumentCode, (response) => {
                        investment.subInvestment = response.investments.map((ele) => {
                            return {
                                moveQuantity: null,
                                acquisitionDate: null,
                                detail: ele,
                                isMoveAll: false,
                                CGT: false,
                                amendBookCost: null,
                            };
                        });

                        request.ModelPortfolioTransfers.forEach((model) => {
                            model.UnderlyingInstrumentTransfers.forEach((transfer) => {
                                data.forEach((investment) => {
                                    investment.subInvestment?.forEach((subInvestment) => {
                                        if (subInvestment.detail.InstrumentCode === transfer.InstrumentCode) {
                                            subInvestment.moveQuantity = transfer.Quantity;
                                            subInvestment.CGT = transfer.CgtExempt;
                                            subInvestment.acquisitionDate = JsonDateParser.toDate(transfer.CgtDate);
                                            subInvestment.amendBookCost = transfer.CgtTotalValue;
                                        }
                                    });
                                });
                            });
                        });

                        this.setState({ investmentData: data });
                    });
                }
            });

            const request = TransferRequestStore.getTransferRequest();
            request.InstrumentTransfers.forEach((transfer) => {
                data.forEach((investment) => {
                    if (investment.detail.InstrumentCode === transfer.InstrumentCode) {
                        investment.moveQuantity = transfer.Quantity;
                        investment.CGT = transfer.CgtExempt;
                        investment.acquisitionDate = JsonDateParser.toDate(transfer.CgtDate);
                        investment.amendBookCost = transfer.CgtTotalValue;
                    }
                });
            });
        }

        if (!hasModel) {this.setState({ investmentData: data });}
    }

    private onTransferRequestStoreChange() {
        const request = TransferRequestStore.getTransferRequest();
        this.setState({ transferRequest: request });
        TransferWizardAction.getSourceAccount(request.SourceHierarchyId);
        TransferWizardAction.getDestinationAccountFromRequest(request.DestinationHierarchyId);
    }

    private onMoveableSubAccountStoreChange() {
        this.setState({ currentAccount: MoveableSubAccountStore.getCurrentAccount() });
        if (getQueryParameters()["hierarchyid"]) {
            TransferWizardAction.getInvestment(getQueryParameters()["hierarchyid"]);
        } else {
            TransferWizardAction.getInvestment(this.state.transferRequest.SourceHierarchyId);
        }
    }

    private onDestinationSubAccountFromRequestStoreChange() {
        const account = DestinationSubAccountFromRequestStore.getData();
        if (account) {
            this.setState({ destinationAccount: account });
        }
    }

    private OnLeaveStepOne(): void {
        const errorMessage: string[] = [];
        if (RestrictionStore.InterAccountTransferDisabled()) {return;}
        if (!this.state.data.DestinationClAccountId) {
            errorMessage.push(errorStepOne.noDesAccount);
        }
        if (
            !this.state.data.InvestmentsTransferDetail ||
            this.state.data.InvestmentsTransferDetail.filter((ele) => ele.MoveQuantity > 0).length < 1
        ) {
            errorMessage.push(errorStepOne.noInvestmentSelect);
        }
        this.child.isValid();
        this.child.investment.isValid();
        if (errorMessage.length == 0 && this.child.isValid() && this.child.investment.isValid()) {
            if (this.child.child) {
                this.child.child.isValid();
                if (!this.child.child.isValid()) {return;}
            }
            const moveInvestments = this.state.data.InvestmentsTransferDetail.filter(
                (ele) => ele.MoveQuantity > 0 && !ele.MoveAllAvailable
            );
            const productIds = moveInvestments.map((ele) => ele.ProductId);
            if (productIds.length > 0) {
                const query: InstrumentSearchQuery = {
                    ProductIds: productIds,
                    CanBeTransferred: true,
                    ServiceProposition: this.state.currentAccount?.ServiceProposition,
                };

                InvestmentSelectionAction.searchInstruments(
                    query,
                    this.state.currentAccount?.HierarchyId,
                    (tradableList: Instrument[]) => {
                        const nonTradable: InvestmentTransferQuery[] = [];
                        moveInvestments.forEach((ele) => {
                            if (!tradableList.some((item) => ele.ProductId == item.ProductId)) {
                                nonTradable.push(ele);
                            }
                        });

                        if (nonTradable.length > 0) {
                            this.setState({
                                errorMsg: [
                                    `These investments are not tradable: ${nonTradable
                                        .map((ele) => ele.InvestmentCode)
                                        .toString()}`,
                                ],
                            });
                        } else {
                            Navigator.navigateToAndPreserveQueryParameters(Urls.get().TransferWizardStepTwo);
                        }
                    }
                );
            } else {
                Navigator.navigateToAndPreserveQueryParameters(Urls.get().TransferWizardStepTwo);
            }
        } else {
            this.setState({ errorMsg: errorMessage });
        }
    }

    private onExit() {
        const customerId = getQueryParameters()["customerid"];

        Navigator.navigateTo(
            Urls.get().main.PortfolioDashboard({
                hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, customerId),
            }).summary
        );
    }

    private onDataChange(key: string, value: any, stateData?: any) {
        const { data } = this.state;
        data[key] = value;
        // change destination account clear the data for change beneficial owner
        if (key.toLowerCase() == "DestinationClAccountId".toLowerCase()) {
            data.IsChangeOfBeneficial = null;
            data.ChangeOfBeneficialOwner = null;
        }
        if (key.toLowerCase() == "IsChangeOfBeneficial".toLowerCase() && value == false) {
            data.ChangeOfBeneficialOwner = null;
        }
        if (key.toLowerCase() == "IsChangeOfBeneficial".toLowerCase() && value == true) {
            data.ChangeOfBeneficialOwner = stateData;
        }
        this.setState({ data });
        if (key.toLowerCase() == "InvestmentsTransferDetail".toLowerCase()) {
            this.setState({ investmentData: stateData });
        }
        if (key.toLowerCase() == "DestinationClAccountId".toLowerCase()) {
            this.setState({ destinationAccount: stateData });
        }
        console.log("data", data);
    }

    private onAuthorise(): void {
        const instruction: AccountTransferInstruction = {
            SourceHierarchyId: this.state.currentAccount.HierarchyId,
            DestinationHierarchyId: this.state.destinationAccount.HierarchyId,
            RequestId: Number.parseInt(getQueryParameters()["requestid"], 10),
            Authorise: true,
        };
        TransferWizardAction.submit(
            instruction,
            () => {
                if (checkPermission(UserClaim.AdviserPortalDluAuthoriseProcessCanView))
                    {window.location.assign("/admin/authorisations/authoriseprocess.aspx");}
            },
            (data) => this.onSubmitFailure(data)
        );
    }

    private onReject(): void {
        const instruction: AccountTransferInstruction = {
            SourceHierarchyId: this.state.currentAccount.HierarchyId,
            DestinationHierarchyId: this.state.destinationAccount.HierarchyId,
            RequestId: Number.parseInt(getQueryParameters()["requestid"], 10),
            Reject: true,
        };
        TransferWizardAction.submit(
            instruction,
            () => {
                if (checkPermission(UserClaim.AdviserPortalDluAuthoriseProcessCanView))
                    {window.location.assign("/admin/authorisations/authoriseprocess.aspx");}
            },
            (data) => this.onSubmitFailure(data)
        );
    }

    private onSubmit(): void {
        if (this.secondChild && !this.secondChild.isValid()) {return;}
        if (this.state.data.Confirmed) {
            this.setState({
                active: false,
                isLoading: true,
            });
            TransferWizardAction.submit(
                this.constructAccountTransferInstruction(),
                () => this.onSubmitSuccess(),
                (data) => this.onSubmitFailure(data)
            );
        } else {
            this.setState({
                errorMsg: ["Please confirm."],
                active: true,
                isLoading: false,
            });
        }
    }

    private onSubmitSuccess(): void {
        this.onExit();
        // Navigator.navigateTo(Urls.get().main.Dashboard, {
        //     queryParamsObject: {
        //         hierarchyid: getQueryParameters()["hierarchyid"],
        //     },
        //     scrollAfterNavigating: true,
        // });
    }

    private onSubmitFailure(apiErrors: IApiError<InterAccountTransferErrors>[]): void {
        this.setState({ errorMsg: this.parseErrorMessages(apiErrors), active: true, isLoading: false });
    }

    private parseErrorMessages(errors: IApiError<InterAccountTransferErrors>[]): string[] {
        return errors.map((error) => submitErrorMessages[error.Error]);
    }

    private onCancel() {
        if (getQueryParameters()["requestid"]) {
            history.back();
        } else {
            this.onExit();
        }
    }

    render() {
        if (!this.state.currentAccount) {return <Spinner />;}
        const requestId = getQueryParameters()["requestid"];
        const stepsConfig: IStepConfig[] = [
            {
                title: stepName.stepOne,
                url: Urls.get().TransferWizardStepOne,
                path: Contents.URLMap.transferWizardStepOne,
                onStepLeave: (from, to) => this.OnLeaveStepOne(),
                component: (
                    <TransferWizardStepOne
                        isReview={requestId > 0}
                        destinationAccount={this.state.destinationAccount}
                        investmentData={this.state.investmentData}
                        onChange={(key, value, data) => this.onDataChange(key, value, data)}
                        data={this.state.data}
                        currentAccount={this.state.currentAccount}
                        onRef={(ref) => (this.child = ref)}
                    />
                ),
            },
            {
                title: stepName.stepTwo,
                url: Urls.get().TransferWizardStepTwo,
                path: Contents.URLMap.transferWizardStepTwo,
                onSubmit: () => this.onSubmit(),
                component: (
                    <TransferWizardStepTwo
                        isAuthorisation={getQueryParameters()["requestid"]}
                        isReview={true}
                        destinationAccount={this.state.destinationAccount}
                        currentAccount={this.state.currentAccount}
                        investmentData={this.state.investmentData}
                        onRef={(ref) => (this.secondChild = ref)}
                        onChange={(key, value, data) => this.onDataChange(key, value, data)}
                        data={this.state.data}
                        onAuthorise={() => this.onAuthorise()}
                        onReject={() => this.onReject()}
                    />
                ),
            },
        ];
        return (
            <>
                <Process
                    stepsConfig={stepsConfig}
                    onCancel={() => this.onCancel()}
                    processTitle="Move assets to new owner"
                    goBacktoFirst={getQueryParameters()["hierarchyid"]}
                    isShowError={false}
                    errorMsg={[]}
                    needSplitHeader={{
                        fromStep: 0,
                        splitHeaderMain: MoveableSubAccountStore.getData().AccountName,
                        splitHeaderSub: MoveableSubAccountStore.getData().HeadClAccountId,
                    }}
                    active={this.state.active}
                    isLoading={this.state.isLoading}
                />
                {this.state.errorMsg.length > 0 && (
                    <Lightbox
                        show={this.state.errorMsg.length > 0}
                        title={"Alert"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ errorMsg: [] })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox is-narrow"
                    >
                        {this.state.errorMsg.map((error, index) => {
                            return <p key={`error-${index}`}>{error}</p>;
                        })}
                        <button className="btn primary" onClick={() => this.setState({ errorMsg: [] })}>
                            OK
                        </button>
                    </Lightbox>
                )}
            </>
        );
    }

    private constructAccountTransferInstruction(): AccountTransferInstruction {
        const modelPortfolioInvestments = this.state.investmentData.filter(
            (x) => x.subInvestment && x.subInvestment.length > 0
        );
        const instrumentTransferQueries = this.state.data.InvestmentsTransferDetail.filter(
            (x) => x.MoveQuantity && x.MoveQuantity > 0
        );

        const individualInstrumentTransfers: InstrumentTransferInstruction[] = instrumentTransferQueries
            .filter((x) => !x.ParentModelInstrumentCode || x.ParentModelInstrumentCode === "")
            .map((investment) => {
                return {
                    InstrumentCode: investment.InvestmentCode,
                    Quantity: investment.MoveQuantity,
                    CgtDate: investment.CgtDate,
                    CgtExempt: investment.CgtExempt,
                    CgtTotalValue: investment.CgtTotalValue,
                };
            });

        const modelPortfolioTransferQueryDict: Dictionary<
            string,
            InvestmentTransferQuery[]
        > = this.groupUnderlyingTransferByModelCode(
            instrumentTransferQueries.filter((x) => x.ParentModelInstrumentCode)
        );
        const modelPortfolioTransferInstructions: ModelPortfolioTransferInstruction[] = [];
        for (const key in modelPortfolioTransferQueryDict) {
            const modelPortfolioInvestment = modelPortfolioInvestments.filter((x) => x.detail.InstrumentCode === key)[0];
            const fullTransferOutUnderlyings = modelPortfolioTransferQueryDict[key].filter(
                (m: InvestmentTransferQuery) => m.MoveAllAvailable
            );
            modelPortfolioTransferInstructions.push({
                ModelInstrumentCode: key,
                FullTransferOut: fullTransferOutUnderlyings.length == modelPortfolioInvestment.subInvestment.length,
                UnderlyingInstrumentTransfers: modelPortfolioTransferQueryDict[key].map(
                    (x: InvestmentTransferQuery) => {
                        return {
                            InstrumentCode: x.InvestmentCode,
                            ProductId: x.ProductId,
                            Quantity: x.MoveQuantity,
                            CgtDate: x.CgtDate,
                            CgtExempt: x.CgtExempt,
                            CgtTotalValue: x.CgtTotalValue,
                        };
                    }
                ),
            });
        }
        let isChangeOfBeneficial = this.state.data.IsChangeOfBeneficial;
        let changeOfBeneficialOwner = this.state.data.ChangeOfBeneficialOwner;
        const hasValueInvestmentData = [];
        this.state.investmentData.forEach((ele) => {
            if (ele.subInvestment) {
                const sub = [];
                ele.subInvestment.forEach((item) => {
                    if (item.moveQuantity > 0 || item.isMoveAll) {
                        sub.push(item);
                    }
                });
                if (sub.length > 0) {
                    hasValueInvestmentData.push({
                        detail: ele.detail,
                        isMoveAll: ele.isMoveAll,
                        moveQuantity: ele.moveQuantity,
                        subInvestment: sub,
                        isToggle: ele.isToggle,
                        amendBookCost: ele.amendBookCost,
                        acquisitionDate: ele.acquisitionDate,
                        CGT: ele.CGT,
                    });
                }
            } else {
                if (ele.isMoveAll || ele.moveQuantity > 0) {
                    hasValueInvestmentData.push(ele);
                }
            }
        });
        if (
            !hasValueInvestmentData.some((ele) =>
                [SecurityType.Share, SecurityType.Bond].includes(ele.detail?.SecurityType)
            )
        ) {
            isChangeOfBeneficial = null;
            changeOfBeneficialOwner = null;
        }

        return {
            SourceHierarchyId: this.state.currentAccount.HierarchyId,
            DestinationHierarchyId: this.state.destinationAccount.HierarchyId,
            ModelPortfolioTransfers: modelPortfolioTransferInstructions,
            InstrumentTransfers: individualInstrumentTransfers,
            Reason:
                this.state.data.Reason === TransferReason.Other
                    ? this.state.data.Detail
                    : ReasonMap[this.state.data.Reason],
            Reference: this.state.data.Reference,
            IsChangeOfBeneficial: isChangeOfBeneficial,
            ChangeOfBeneficialOwner: changeOfBeneficialOwner,
        };
    }

    private groupUnderlyingTransferByModelCode(
        xs: InvestmentTransferQuery[]
    ): Dictionary<string, InvestmentTransferQuery[]> {
        const dict = {};

        xs.forEach((x) => {
            (dict[x.ParentModelInstrumentCode] = dict[x.ParentModelInstrumentCode] || []).push(x);
        });
        return dict as Dictionary<string, InvestmentTransferQuery[]>;
    }
}
